"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmSiteSchema = exports.CrmDealsheetSchema = void 0;
var crm_dealsheet_1 = require("./crm-dealsheet");
Object.defineProperty(exports, "CrmDealsheetSchema", { enumerable: true, get: function () { return crm_dealsheet_1.CrmDealsheetSchema; } });
var crm_site_1 = require("./crm-site");
Object.defineProperty(exports, "CrmSiteSchema", { enumerable: true, get: function () { return crm_site_1.CrmSiteSchema; } });
//# sourceMappingURL=index.js.map